import { createContext, useContext, RefObject } from 'react';

/**
 * Context that provides a reference to the phone frame container element.
 * Portals (sheets, modals, overlays) should render into this container
 * instead of document.body when inside the phone frame on desktop.
 */
const PhoneFrameContext = createContext<RefObject<HTMLDivElement | null> | null>(null);

export const PhoneFrameProvider = PhoneFrameContext.Provider;

/**
 * Returns the portal container element.
 * Inside the phone frame → returns the frame element.
 * Outside (mobile / marketing) → returns document.body.
 */
export function usePortalContainer(): HTMLElement {
  const frameRef = useContext(PhoneFrameContext);
  return frameRef?.current ?? document.body;
}
